import {createStylesContext} from '@chakra-ui/react'

export const [ProductTileStyleProvider, useProductTileStyles] = createStylesContext('ProductTile')
